import React, { Component } from 'react';
import classNames from 'classnames';

const empty = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

export default class Image extends Component {
  state = {
    error: false,
  };

  onError = () => {
    this.setState({
      error: true,
    });
  };

  render() {
    const { error } = this.state;
    const { alt, title, background, children, className, ref, src, style, onClick } = this.props;
    const finalStyle = {
      backgroundImage: (background || children) ? `url(${src})` : '',
      ...style,
    };
    let result = empty;

    if (!error) {
      result = src;
    }

    if (!src) {
      result = empty;
    }

    if (children) {
      const Comp = onClick ? 'button' : 'div';
      return (
        <Comp
          className={classNames('focus:outline-none', className)}
          style={finalStyle}
          onClick={onClick}
        >
          {children}
        </Comp>
      );
    }

    return (
      <img
        src={background ? empty : result}
        className={className}
        onError={this.onError}
        alt={alt}
        title={title}
        style={finalStyle}
        ref={ref}
      />
    );
  }
}
